module.exports = __webpack_public_path__ + "static/media/pattern.e5cb9076.png";